import { sort } from '../utils/helpers';

export const UPDATE_STATUS = (state, status) => (state.status = status);

export const RESET_ERRORS = state => (state.errors = []);

export const SET_ERROR = (state, error) => {
  if (typeof error === 'object' && Array.isArray(state.errors)) {
    state.errors = state.errors.concat(error);
  }
}

export const SET_ITEMS = (state, data) => {
  state.items = data.data.items;
  state.nextUrl = data.links.next;
  state.total = data.meta.total;
}

export const ADD_ITEMS = (state, data) => {
  state.items = state.items.concat(data.data.items);
  state.nextUrl = data.links.next;
}

export const ADD_ITEM = (state, data) => {
  if (!data.item) {
    return;
  }

  const item = data.item;

  // check to see if item is already in items array
  // if it is then all we need to do is add prev/next
  // if not we need to add it to the array

  const inList = state.items.find(o => {
    return o.slug === data.item.slug;
  });

  if (!inList) {
    item.next = data.next;
    item.prev = data.prev;

    state.items = state.items.concat(item);
  } else {
    state.items = state.items.map(o => {
      if (o.slug === data.item.slug) {
        o.next = data.next;
        o.prev = data.prev;
      }

      return o;
    });
  }
}

export const UPDATE_ITEM = (state, data) => {
  const item = data.item;

  state.items = state.items.map(o => {
    if (o.slug === data.item.slug) {
      o = item;
    }

    return o;
  });
}

export const REMOVE_ITEM = (state, slug) => {
  state.items = state.items.filter(o => {
    return o.slug !== slug;
  });
}

export const SET_NEXT_URL = (state, { slug, url }) => {
  // console.log('slug', state.items);
  const item = state.items.find(o => o.slug === slug);

  // console.log('SET_NEXT_URL - item', item);

  if (item) {
    item.nextUrl = url;
    // console.log('SET_NEXT_URL - next url', item.nextUrl)

    // console.log('SET_NEXT_URL - item', item);
  }
}

export const CLEAR_ITEMS = (state) => {
  state.items = [];
}

export const UPDATE_DISPLAY_STYLE = (state, { display }) => {
  state.displayStyle = display;
}

export const SORT_ITEMS = (state, { direction, field = 'name' }) => {
  state.sort = { direction, field };
  // console.log('items', state.items);

  if (state.items && state.items.length) {
    state.items = sort([...state.items], direction, field);
  }
}

export default {
  UPDATE_STATUS,
  RESET_ERRORS,
  SET_ERROR,
  SET_ITEMS,
  ADD_ITEMS,
  ADD_ITEM,
  UPDATE_ITEM,
  REMOVE_ITEM,
  SET_NEXT_URL,
  CLEAR_ITEMS,
  UPDATE_DISPLAY_STYLE,
  SORT_ITEMS,
};
